// In your main routing file (App.js or routes.js)
import React from "react";
import { Route, Switch } from "react-router-dom";
import FreightBookingsList from './FreightrateBookingList'; // Adjust path as needed
import FreightBookingDetails from './FreightrateBookingDetails'; // Adjust path as needed

const FreightBookings = ({ match }) => {
  console.log("FreightBookings route match:", match);
  return (
    <Switch>
      <Route exact path={`${match.path}`} component={FreightBookingsList} />
      <Route path={`${match.path}/details/:id`} component={FreightBookingDetails} />
    </Switch>
  );
};

export default FreightBookings;